"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
/**
 * Activate retries for failed requests.
 * @param instance The Axios instance to activate retries for.
 */
function activateRetries(instance) {
    // Attach reference of the instance to the instance config so we can use it during requests.
    // This makes use of AxiosRequestConfig
    instance.defaults.retryConfig = {
        instance: instance
    };
    // Based on Axios Interceptors. For more information on how interceptors
    // work go to the Axios repo: https://github.com/axios/axios#interceptors
    instance.interceptors.response.use(null, onError);
}
exports.default = activateRetries;
function onError(error) {
    var config = error.config;
    if (axios_1.default.isCancel(error)) {
        return Promise.reject(error);
    }
    if (!config || !config.retryConfig) {
        return Promise.reject(error);
    }
    var retryConfig = config.retryConfig;
    retryConfig.currentRetry = retryConfig.currentRetry || 0;
    if (!shouldRetry(error)) {
        return Promise.reject(error);
    }
    var delay = ((Math.pow(2, retryConfig.currentRetry) - 1) / 2) * 1000;
    retryConfig.currentRetry += 1;
    return new Promise(function (resolve, reject) {
        return setTimeout(function () {
            retryConfig.instance.request(config).then(resolve).catch(reject);
        }, delay);
    });
}
function shouldRetry(error) {
    var config = error.config.retryConfig;
    if (error.response && error.response.status) {
        var status_1 = error.response.status;
        var isInRange = false;
        // TODO: Turn this into a config option
        if (status_1 >= 500 && status_1 <= 599) {
            isInRange = true;
        }
        if (!isInRange) {
            return false;
        }
    }
    if (config.currentRetry === 4) {
        return false;
    }
    return true;
}
//# sourceMappingURL=retry.js.map